import en from "./en";
import es from "./es";
import de from "./de";
import fr from "./fr";
import ja from "./ja";
import zhCN from "./zh-CN";
import zhTW from "./zh-TW";
import th from "./th";
import vi from "./vi";
import ko from "./ko";
import ar from "./ar";
import hi from "./hi";

/** All i18n translation resources keyed by BCP 47 language code. */
export const resources = {
  en,
  es,
  de,
  fr,
  ja,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  th,
  vi,
  ko,
  ar,
  hi,
};
